import type { ApiEventId } from 'api/types/ApiTypedId';
import type { ApiRsvpData } from 'modules/listing/events/api/types/ApiRsvpResponse';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

function mapResponse(response: ApiRsvpData) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: ApiEventId) =>
    `/data/website/events/${eventId}/rsvp-data`,
  mapResponse,
});

// Exports

export const listingApiFetchRsvpData = endpoint.createClientFetchFn();

export const useListingApiFetchRsvpData = endpoint.createUseFetchHook();
